/// <reference path="../../svg.d.ts" />
import React from 'react';
import { PackageCheck, Check, Clock } from 'lucide-react';
import { getIconProps, IconProps } from '../../utils';
import LoadsSvg from '../../assets/order/loads.svg?react';
import PackageSvg from '../../assets/order/package.svg?react';
import PackdownSvg from '../../assets/order/packdown.svg?react';
import CancelSvg from '../../assets/order/cancel.svg?react';
import { LocationWithCheckMarkIcon } from '../Location';
import { OrderStatusConfirmedIcon, OrderStatusDeliveredIcon } from './OrderStatus';

/** Order booked/created icon - used for timeline */
export const OrderBookedIcon: React.FC<IconProps> = props => {
  return <LoadsSvg {...getIconProps(props)} />;
};

/** Order confirmed icon - checkmark in circle */
export const OrderConfirmedIcon: React.FC<IconProps> = props => {
  return <OrderStatusConfirmedIcon {...getIconProps(props)} />;
};

/** Arrived icon - simple check (lucide) */
export const ArrivedIcon: React.FC<IconProps> = props => {
  return <LocationWithCheckMarkIcon {...getIconProps(props)} />;
};

/** Picked up icon - package with check */
export const PickedUpIcon: React.FC<IconProps> = props => {
  return <PackageSvg {...getIconProps(props)} />;
};

/** Drop off icon - open package */
export const DropOffIcon: React.FC<IconProps> = props => {
  return <PackdownSvg {...getIconProps(props)} />;
};

/** Completed icon - check in circle (success) */
export const CompletedIcon: React.FC<IconProps> = props => {
  // return <CorrectSvg {...getIconProps(props)} />;
  return <OrderStatusDeliveredIcon {...getIconProps(props)} />;
};

/** Canceled icon - X in circle */
export const CanceledIcon: React.FC<IconProps> = props => {
  return <CancelSvg {...getIconProps(props)} />;
};

/** Start Journey icon - Clock for scheduled/waiting to start */
export const StartJourneyIcon: React.FC<IconProps> = props => {
  return <Clock {...getIconProps(props)} />;
};
